module.exports = "<div class=panel ng-class=\"vm.panelClass || 'panel-default'\"> <div class=panel-heading> <h3 class=panel-title><i ng-if=vm.titleIcon ng-class=vm.titleIcon></i> {{vm.titleText | translate}}</h3> </div> <div class=panel-body ng-transclude></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-agreement-answer/cn-agreement-answer.html
 ** module id = 121
 ** module chunks = 0
 **/